import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Team.css';
import Footer from '../components/Footer.js';

const Team = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const teamMembers = [
    { name: 'Mercy Kamau', title: 'Managing Partner', photo: 'mercymain.jfif' },
    { name: 'Peter Macharia', title: 'Legal Associate', photo: 'peter.jpg' },
    { name: 'Kelvin Kahia', title: 'Legal Associate', photo: 'kevin.jpg' },
    { name: 'Millicent Gathoni', title: 'Manager', photo: 'millicent.jpg' },
    { name: 'Lilian Motari', title: 'Associate Partner', photo: 'lilian.jpg' },
    { name: 'Shadrack Kiarie', title: 'Head of Corporate and Governance Division', photo: 'shadrack.jpg' },
    { name: 'Vivian Kioko', title: 'Corporate and Governance Assistant', photo: 'vivian.jpg' },
    { name: 'Kevin Kebande', title: 'Administrative Staff', photo: 'kelvin.jpg' },
    { name: 'Lucas Okumu', title: 'Administrative Staff', photo: 'lucas.jpg' },
    { name: 'Mlka Mwangi', title: 'Administrative Staff', photo: 'milkah.jpg' },
    { name: 'Henry Mwaniki', title: 'Administrative Staff', photo: 'henry.jpg' },
    { name: 'David Mbutura', title: 'Head of Corporate Social Responsibility and Probono Services', photo: 'davy.jpg' },
    { name: 'Mercy Mbatia', title: 'Pupil', photo: 'mercy.jpg' },
    { name: 'Samuel Kiarie', title: 'ICT Assistant', photo: 'sam.jpg' },
  ];
  useEffect(() => {
    const hash = location.hash.substring(1);
    if (hash) {
      const member = teamMembers.find(m => 
        m.name.toLowerCase().replace(/ /g, '-') === hash
      );
      if (member) setSelectedMember(member);
    }
  }, [location]);

  const handleMemberClick = (member) => {
    setSelectedMember(member);
    navigate(`#${member.name.toLowerCase().replace(/ /g, '-')}`);
  };

  const closeModal = () => {
    setSelectedMember(null);
    navigate('#');
  };

  return (
    <div>
      <div className="team-page">
        <h1>Our Legal Team</h1>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div 
              className="team-member" 
              key={index}
              onClick={() => handleMemberClick(member)}
            >
              <div className="member-photo">
                <img src={`/team/${member.photo}`} alt={member.name} />
              </div>
              <h3>{member.name}</h3>
              <p>{member.title}</p>
            </div>
          ))}
        </div>
      </div>

      {selectedMember && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>&times;</button>
            <div className="modal-image">
              <img 
                src={`/team/${selectedMember.photo}`} 
                alt={selectedMember.name} 
              />
            </div>
            <h2>{selectedMember.name}</h2>
            <p className="modal-title">{selectedMember.title}</p>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Team;